import { useLocation, useParams } from 'react-router';

const useJobId = () => {
	const { jobId } = useParams();
	const location = useLocation();

	if (jobId) {
		return jobId;
	}

	return new URLSearchParams(location.search.toLowerCase()).get('jobid');
};

export default useJobId;
